"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = Modal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const styled_components_1 = __importDefault(require("styled-components"));
const styled_breakpoints_1 = require("styled-breakpoints");
const StyledModal = (0, styled_components_1.default)(antd_1.Modal) `
	top: 1rem;

	${(0, styled_breakpoints_1.down)('sm')} {
		margin: 0;
		max-width: 100vw;
		width: 100vw !important;
		top: 0;
		min-height: 100vh;
		padding: 0;
		display: flex;

		.ant-modal-content {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			width: 100%;
			height: fit-content;
			min-height: 100%;
			border-radius: 0;
		}

		.ant-modal-body {
			padding: 1rem;
			flex: 1;
		}

		.ant-modal-footer {
			display: flex;
			flex-wrap: wrap;
			gap: 1rem;
			justify-content: flex-end;
		}
	}
`;
function Modal(props) {
    const onCancel = e => {
        if (props === null || props === void 0 ? void 0 : props.onCancel) {
            // @ts-ignore
            document.body.style = '';
            props === null || props === void 0 ? void 0 : props.onCancel(e);
        }
    };
    return ((0, jsx_runtime_1.jsx)(StyledModal, { ...props, onCancel: onCancel, children: props.children }));
}
